@if (iso) { @if (isToday && !isPrecise) {
<span>Today</span>
} @if (!isToday || isPrecise) {
<span>{{ time | amTimeAgo }}</span>
} } @if (!iso) {
<empty>Never</empty>
}
